export const FETCH_ADMIN_ROLE_ACCESS_REQUEST = 'FETCH_ADMIN_ROLE_ACCESS_REQUEST';
export const FETCH_ADMIN_ROLE_ACCESS_SUCCESS = 'FETCH_ADMIN_ROLE_ACCESS_SUCCESS';
export const FETCH_ADMIN_ROLE_ACCESS_FAILURE = 'FETCH_ADMIN_ROLE_ACCESS_FAILURE';
